export const viewTitle = "Список ТК";
export const viewUniqKey = "tk-list";
